import React from 'react';
import { LinkProps, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EMPTY_STRING } from 'constants/shared';
import styles from 'components/menu/menu.module.css';
import { HOME_URL } from 'constants/navigation';

export const LanguageLink: React.FC<LinkProps> = ({
    to,
    children,
    onClick,
    ...props
}) => {
    const { i18n } = useTranslation();

    const getLocalizedPath = (): string => {
        const path = typeof to === 'string' ? to : to.pathname || EMPTY_STRING;
        const cleanPath = path.startsWith(HOME_URL) ? path : `/${path}`;
        return i18n.language === 'en' ? `/en${cleanPath}` : cleanPath;
    };

    return (
        <NavLink
            to={getLocalizedPath()}
            {...props}
            className={styles.menuLink}
            onClick={onClick}
        >
            {children}
        </NavLink>
    );
};
